/**
 * @see https://github.com/facebook/relay/issues/4548
 */
// Because Relay is a CommonJS module, we are having problems with Vite bundling it.
// Until Relay becomes an ESM module, we need to use this package to re-export it.
import { default as reactRelay } from 'react-relay';
import { default as relayRuntime } from 'relay-runtime';
export const ConnectionHandler = relayRuntime.ConnectionHandler;
export const Environment = relayRuntime.Environment;
export const Network = relayRuntime.Network;
export const QueryResponseCache = relayRuntime.QueryResponseCache;
export const RecordSource = relayRuntime.RecordSource;
export const Store = relayRuntime.Store;
export const loadQuery = reactRelay.loadQuery;
export const fetchQuery = reactRelay.fetchQuery;
export const useLazyLoadQuery = reactRelay.useLazyLoadQuery;
export const usePreloadedQuery = reactRelay.usePreloadedQuery;
export const graphql = reactRelay.graphql;
export const useFragment = reactRelay.useFragment;
export const useMutation = reactRelay.useMutation;
export const usePaginationFragment = reactRelay.usePaginationFragment;
export const useRelayEnvironment = reactRelay.useRelayEnvironment;
export const readInlineData = reactRelay.readInlineData;
export const useRefetchableFragment = reactRelay.useRefetchableFragment;
export const RelayEnvironmentProvider = reactRelay.RelayEnvironmentProvider;
export const commitMutation = reactRelay.commitMutation;
export const useQueryLoader = reactRelay.useQueryLoader;
//# sourceMappingURL=index.js.map